export const storeValue = (key, value) => {
  return localStorage.setItem(key, JSON.stringify(value));
};
export const removeStoredValue = (key) => {
  return localStorage.removeItem(key);
};
export const getStoredValue = (key) => {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : null;
};
